import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres72u/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres72u/labels')
  },
  getIndex (searchParams) {
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      sendParams = {
        p_dtest: (typeof searchParams.dteapprst !== 'undefined' ? searchParams.dteapprst : ''),
        p_dteen: (typeof searchParams.dteappren !== 'undefined' ? searchParams.dteappren : ''),
        p_staappr: (typeof searchParams.staappr !== 'undefined' ? searchParams.staappr : 'P'),
        p_codempid: (typeof searchParams.codempid !== 'undefined' ? searchParams.codempid : '')
      }
    }
    if (isMock) return generator(mocker.index())
    return instance().get(endpoint + '/hres72u/index', { params: sendParams })
  },
  getDetail (detailParams) {
    let searchParams = {
      p_codempid: detailParams.codempid,
      p_dtereq: detailParams.dtereq.replace(/\//g, ''),
      p_numseq: detailParams.numseq,
      p_typpatient: detailParams.typpatient,
      p_codrel: detailParams.codrel
    }
    if (isMock) return generator(mocker.detail())
    const params = searchParams.p_codempid + '/' + searchParams.p_dtereq + '/' + searchParams.p_numseq + '/' + searchParams.p_typpatient + '/' + searchParams.p_codrel
    return instance().get(endpoint + '/hres72u/detail/' + params)
  },
  getDetailTab2Popup (popupParams) {
    let searchParams = {
      p_codempid: popupParams.codempid,
      p_codcln: popupParams.codcln,
      p_coddcal: popupParams.coddcal,
      p_codrel: popupParams.codrel
    }
    if (isMock) return generator(mocker.detailTab2Popup())
    const params = searchParams.p_codempid + '/' + searchParams.p_codcln + '/' + searchParams.p_coddcal + '/' + searchParams.p_codrel
    return instance().get(endpoint + '/hres72u/detailTab2Popup/' + params)
  },
  getDetailSubmit (detailParams) {
    let searchParams = {
      p_codempid: detailParams.codempid,
      p_dtereq: detailParams.dtereq.replace(/\//g, ''),
      p_numseq: detailParams.numseq,
      p_approvno: detailParams.approvno,
      p_staappr: detailParams.staappr
    }
    const params = searchParams.p_codempid + '/' + searchParams.p_dtereq + '/' + searchParams.p_numseq + '/' + searchParams.p_approvno + '/' + searchParams.p_staappr
    if (isMock) return generator(mocker.detailSubmit())
    return instance().get(endpoint + '/hres72u/detailSubmit/' + params)
  },
  postSendApprove (approveParams) {
    let paramJson = {
      '0': {
        p_staappr: approveParams.flgStaappr,
        p_approvno: approveParams.approvno,
        p_chk_appr: approveParams.chk_appr,
        p_numseq: approveParams.numseq,
        p_codempid: approveParams.codempid,
        p_dtereq: approveParams.dtereq.replace(/\//g, ''),
        p_dteappr: approveParams.dteappr.replace(/\//g, ''),
        p_amtalw: approveParams.amtalw,
        p_remark: approveParams.remark,
        p_flgwarn: approveParams.flgwarning
      }
    }
    let sendParams = {
      param_json: JSON.stringify(paramJson),
      remarkApprove: (approveParams.flgStaappr === 'A') ? approveParams.remark : '',
      remarkReject: (approveParams.flgStaappr === 'N') ? approveParams.remark : ''
    }
    if (isMock) return generator(mocker.sendApprove())
    return instance().post(endpoint + '/hres72u/sendApprove', sendParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hres72u/index.js